export const StyleGenerator = (styleString) => JSON.parse(styleString);

export const colors = {
  primary: "#4F6D7A",
  darkenedPrimary: "#28373E",
  highlight: "#F7B32B",
  textInvertColor: "#FEFEFE",
  coloredBG: "#4F6D7A",
  textColor: "#101619",
  error: "red",
  accent: "#702632",
};

export const ErrorStyle = {
  color: colors.error,
};

export const LinkStyle = {
  color: colors.highlight,
};

export const isMobile = () => window.matchMedia("(max-width: 600px)").matches;

export const AboutPageStyle = {
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  minHeight: "100%",
  marginTop: "20px",
  width: "100%",
};
// This allows the footer to be pushed to the bottom on safari
if (isMobile()) AboutPageStyle.height = "initial";

export const ContentStyle = {
  margin: 20,
  textAlign: "justify",
  width: isMobile() ? "90%" : "80%",
  minHeight: "100%",
  maxWidth: 800,
  minWidth: 200,
  flexGrow: 3,
};
